import { MedicareBridgeChecklistItem } from './medicare-bridge.types';

export function outstandingRequirementLabels(
  items: MedicareBridgeChecklistItem[],
  keys: string[],
): { key: string; label: string }[] {
  return keys.map((key) => ({
    key,
    label: items.find((item) => item.key === key)?.label ?? key,
  }));
}
